var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.loading && !_vm.isMarketingElementsEmpty
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("v-app", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-end" },
                  [
                    _vm.removeButtonVisible
                      ? _c("erase-icon-button", {
                          staticClass: "mr-2",
                          on: { click: _vm.onDelete },
                        })
                      : _vm._e(),
                    _c("business-guide-search", {
                      model: {
                        value: _vm.searchValue,
                        callback: function ($$v) {
                          _vm.searchValue = $$v
                        },
                        expression: "searchValue",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading && _vm.isMarketingElementsEmpty
        ? _c("ib-list-view-placeholder", {
            attrs: {
              title: _vm.$tc("addMarketingCost"),
              disabled: !_vm.canEdit || _vm.disabled,
            },
            on: { click: _vm.onShowAddNewDialog },
          })
        : [
            !_vm.loading
              ? _c(
                  "el-row",
                  { staticClass: "d-flex flex-wrap", attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { md: 12 } },
                      [
                        _c("add-new-card", {
                          staticClass: "mb-2 py-md-0",
                          attrs: {
                            disabled: !_vm.canEdit,
                            title: _vm.$tc("addMarketingCost"),
                            horizontal: "",
                            "min-height": "62px",
                          },
                          on: { click: _vm.onShowAddNewDialog },
                        }),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.filterMarketingBudget,
                      function (marketingElement) {
                        return _c(
                          "el-col",
                          {
                            key: marketingElement.id,
                            staticClass: "d-flex mb-2",
                            attrs: { md: 12 },
                          },
                          [
                            _c("set-up-and-projections-card", {
                              staticClass: "w-100",
                              attrs: {
                                entity: marketingElement,
                                name: marketingElement.name,
                                date: _vm.marketingElementDate(
                                  marketingElement
                                ),
                                amount:
                                  _vm.marketingElementAmount(marketingElement),
                                frequency:
                                  marketingElement.intervalType === "one_time"
                                    ? _vm.$t("pages.businessGuide.oneTime")
                                    : _vm.$t(
                                        "pages.businessGuide.monthlyAverage"
                                      ),
                                type: `${marketingElement.categoryGroup}_marketing_budget`,
                                disabled: !_vm.canEdit,
                                view: "list",
                              },
                              on: {
                                edit: _vm.onEditMarketingElement,
                                copy: _vm.onCopyMarketingElement,
                                delete: _vm.onDeleteMarketingElement,
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ],
      _vm.canEdit
        ? _c("dialog-add-marketing-budget", {
            attrs: {
              "marketing-element-action": _vm.marketingElementAction,
              "dialog-add-marketing-element-visible": _vm.dialogAddNewVisible,
              "on-edit-marketing-element": _vm.onEditMarketingElement,
              "on-copy-marketing-element": _vm.onCopyMarketingElement,
              "on-delete-marketing-element": _vm.onDeleteMarketingElement,
            },
            on: {
              "close-dialog-add-marketing-element": function ($event) {
                _vm.dialogAddNewVisible = false
              },
              "close-dialog-on-button": function ($event) {
                _vm.dialogAddNewVisible = false
              },
              "on-update-marketing-budget-view": function ($event) {
                return _vm.onUpdateAddNewDialog()
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }